"use client";

import React from "react";
import * as S from "./styles";
import { ReportCollaboratorProps } from "@/types";
import { formatCurrency } from "@/utils/formatCurrency";
import ButtonIcon from "@/components/buttonIcon";
import { Download, History } from "lucide-react";

type Props = {
  item: any;
  currency: string;
  dict: Record<string, string>;
  onOpenHistory?: () => void;
  onDownload?: () => void;
};

const CardEmployeeReport: React.FC<Props> = ({
  item,
  currency,
  dict,
  onOpenHistory,
  onDownload,
}) => {
  const employee = item.employee || { name: "-" };

  const services =
    Number(item.serviceCommissionAmount ?? 0) +
    Number(item.packageServiceCommissionAmount ?? 0);
  const products = Number(item.productCommissionAmount ?? 0);
  const subscriptions = Number(item.subscriptionCommissions ?? 0);
  const packageService = Number(item.packageServiceCommissionAmount ?? 0);
  const packageCommission = Number(item.packageCommissionAmount ?? 0);
  const vouchers = Number(item.vouchers ?? item.totalVouchers ?? 0);
  const extras = Number(item.extras ?? 0);
  const total =
    services + products + subscriptions + packageCommission + vouchers + extras;

  return (
    <S.CardServiceReport>
      <S.Header>
        <S.Employee>
          <S.Avatar>
            {/* placeholder avatar initials */}
            {employee.name ? employee.name.charAt(0).toUpperCase() : "-"}
          </S.Avatar>
          <div>
            <S.Name>{employee.name}</S.Name>
            <S.Small>{item.employee?.role ?? ""}</S.Small>
          </div>
        </S.Employee>
        <S.Actions>
          <ButtonIcon icon={<History />} onClick={onOpenHistory} />
          <ButtonIcon icon={<Download />} onClick={onDownload} />
        </S.Actions>
      </S.Header>

      <S.Body>
        <S.Row>
          <S.Label>{dict["Services Commission"]}</S.Label>
          <S.Value>{formatCurrency(services, currency)}</S.Value>
        </S.Row>
        <S.Row>
          <S.Label>{dict["Products Commission"]}</S.Label>
          <S.Value>{formatCurrency(products, currency)}</S.Value>
        </S.Row>
        <S.Row>
          <S.Label>{dict["Subscription Commissions"]}</S.Label>
          <S.Value>{formatCurrency(subscriptions, currency)}</S.Value>
        </S.Row>
        <S.Row>
          <S.Label>{dict["Packages Commission"]}</S.Label>
          <S.Value>
            {formatCurrency(packageService || packageCommission, currency)}
          </S.Value>
        </S.Row>
        <S.Row>
          <S.Label>{dict["Vouchers"]}</S.Label>
          <S.Value>{formatCurrency(vouchers, currency)}</S.Value>
        </S.Row>
        <S.Row>
          <S.Label>{dict["Extras"]}</S.Label>
          <S.Value>{formatCurrency(extras, currency)}</S.Value>
        </S.Row>
      </S.Body>

      <S.Footer>
        <S.TotalLabel>{dict["Total Commissions"]}</S.TotalLabel>
        <S.TotalValue>{formatCurrency(total, currency)}</S.TotalValue>
      </S.Footer>
    </S.CardServiceReport>
  );
};

export default CardEmployeeReport;
